/* eslint-disable */
// Auto-generated API paths
// Do not edit manually - regenerate using generate-api-types.sh
export var API_PATHS = {
    /**
     * Path: /czna-users/users/me
     * GET: Get current user profile
     * Response: User
     * PUT: Update current user profile
     * Request: UserProfileUpdateRequest
     * Response: User
     */
    CZNA_USERS_USERS_ME: 'czna-users/users/me',
    /**
     * Path: /czna-users/users
     * GET: Get users collection
     * Response: CollectionResponseDto
     * POST: Create a new user
     * Request: User
     * Response: User
     */
    CZNA_USERS_USERS: 'czna-users/users',
    /**
     * Path: /czna-users/organizations
     * GET: Get organizations collection
     * Response: CollectionResponseDto
     * POST: Create a new organization
     * Request: Organization
     * Response: Organization
     */
    CZNA_USERS_ORGANIZATIONS: 'czna-users/organizations',
    /**
     * Path: /_/tenant
     * POST: Create tenant job (create, upgrade, delete)
     * Request: tenantAttributes
     * Response: void
     */
    TENANT: '_/tenant',
};
// Parameterized path functions
/**
 * Path: /czna-users/users/{id}
 * GET: Get user by ID
 * Response: User
 * PUT: Update user
 * Request: User
 * Response: User
 * DELETE: Delete user
 * Response: void
 */
export var cznaUsersUsersId = function (id) { return "czna-users/users/".concat(id); };
/**
 * Path: /czna-users/users/{id}/authority-type-roles/{roleId}
 * PUT: Update authority type role
 * Request: AuthorityTypeRoleAssignmentRequest
 * Response: UserRoleAuthorityType
 * DELETE: Remove authority type role from user
 * Response: void
 */
export var cznaUsersUsersIdAuthorityTypeRolesRoleid = function (id, roleId) { return "czna-users/users/".concat(id, "/authority-type-roles/").concat(roleId); };
/**
 * Path: /czna-users/organizations/{id}
 * GET: Get organization by ID
 * Response: Organization
 * PUT: Update organization
 * Request: Organization
 * Response: Organization
 * DELETE: Delete organization
 * Response: void
 */
export var cznaUsersOrganizationsId = function (id) { return "czna-users/organizations/".concat(id); };
/**
 * Path: /czna-users/users/{id}/roles
 * GET: Get user global roles
 * Response: UserRole[]
 * POST: Add global role to user
 * Request: RoleAssignmentRequest
 * Response: UserRole
 */
export var cznaUsersUsersIdRoles = function (id) { return "czna-users/users/".concat(id, "/roles"); };
/**
 * Path: /czna-users/users/{id}/password-reset
 * POST: Reset user password (admin)
 * Response: void
 */
export var cznaUsersUsersIdPasswordReset = function (id) { return "czna-users/users/".concat(id, "/password-reset"); };
/**
 * Path: /czna-users/users/{id}/authority-type-roles
 * GET: Get user authority type roles
 * Response: UserRoleAuthorityType[]
 * POST: Add authority type role to user
 * Request: AuthorityTypeRoleAssignmentRequest
 * Response: UserRoleAuthorityType
 */
export var cznaUsersUsersIdAuthorityTypeRoles = function (id) { return "czna-users/users/".concat(id, "/authority-type-roles"); };
/**
 * Path: /czna-users/organizations/{id}/users
 * GET: Get users in organization
 * Response: CollectionResponseDto
 */
export var cznaUsersOrganizationsIdUsers = function (id) { return "czna-users/organizations/".concat(id, "/users"); };
/**
 * Path: /_/tenant/{operationId}
 * GET: Does tenant id already exist
 * Response: string
 * DELETE: drop tenant id
 * Response: void
 */
export var tenantOperationid = function (operationId) { return "_/tenant/".concat(operationId); };
/**
 * Path: /czna-users/users/{id}/roles/{role}
 * DELETE: Remove global role from user
 * Response: void
 */
export var cznaUsersUsersIdRolesRole = function (id, role) { return "czna-users/users/".concat(id, "/roles/").concat(role); };
